
import Vue from 'vue'

export default Vue.extend({
   name: 'LoadingIndicator',
   props: {
      loading: { type: Boolean, default: false },
      hideLabel: { type: Boolean, default: false },
      label: { type: String, default: 'Loading' },
   },
})
